import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';
import { DATE_FORMAT } from '../../../constants';
import {
  formSummaryRecipientOptions,
  notificationOptions,
  formSummaryShouldBeSentAfterDaysOptions,
  timeOptions,
  formSummarySendingTimesOptions,
  formSummaryStopType,
  formSummarySendingValueOptions,
  formSummaryStopPeriodTimesOptions,
} from '../../../constants/forms/options';
import { updateForm } from '../../../services/form';
import AttachPdfToEmailSetting from './components/attach-pdf-to-email-setting';
import FormSummarySettings from './components/form-summary-setting';
import { DateObject } from 'react-multi-date-picker';

const SET_FORM_SUBMITTER_NOTIFICATION_KEY = 'should_submitters_receive_notifications';
const initialNotificationsSettings = {
  submitters_notification_type: '',
  submitters_notification_text: '',
  should_form_initiator_receive_notifications: false,
  should_form_recipients_receive_notifications: false,
  form_initiator_notification_type: '',
  form_initiator_notification_text: '',
  form_recipients_notification_type: '',
  form_recipients_notification_text: '',
  should_notify_about_form_summary: false,
  form_summary_recipient_type: '',
  form_summary_notification_type: '',
  form_summary_send_form_completion: false,
  form_summary_send_amount_of_people_who_submitted_form: false,
  form_summary_send_amount_of_people_who_did_not_submit_form: false,
  form_summary_send_list_of_people_who_submitted_form: false,
  form_summary_send_list_of_people_who_did_not_submit_form: false,
  form_summary_notification_sends_amount: null,
  form_summary_notification_should_be_sent_after_days_amount: null,
  form_summary_notification_sending_times: null,
  form_summary_notification_sending_value: null,
  form_summary_notification_sending_week_days: [],
  form_summary_notification_sending_month_days: [],
  form_summary_notification_send_at_time: null,
  form_summary_notification_stop_type: null,
  form_summary_notification_stop_on_date: null,
  form_summary_notification_stop_period_times: null,
  form_summary_notification_stop_period_value: null,
  [SET_FORM_SUBMITTER_NOTIFICATION_KEY]: false,
};

export const NotificationSettings = ({ formData }) => {
  const { id } = useParams();
  const navigation = useNavigate();
  const formType = formData?.submission_settings?.filling_type;

  const [notifications_settings, setNotificationsSettings] = useState(initialNotificationsSettings);
  const [errors, setErrors] = useState(null);

  useEffect(() => {
    if (formData?.notifications_settings?.hasOwnProperty('submitters_notification_type')) {
      setNotificationsSettings((prevState) => {
        const newState = { ...prevState, ...formData.notifications_settings };

        if (!formData.notifications_settings.should_form_initiator_receive_notifications) {
          newState.should_form_initiator_receive_notifications = false;
        }
        if (!formData.notifications_settings.should_form_recipients_receive_notifications) {
          newState.should_form_recipients_receive_notifications = false;
        }

        if (formData.notifications_settings.submitters_notification_type) {
          newState.submitters_notification_type = notificationOptions.find(
            (item) => item.value === formData.notifications_settings.submitters_notification_type,
          );
        }

        if (formData.notifications_settings.form_recipients_notification_type) {
          newState.form_recipients_notification_type = notificationOptions.find(
            (item) => item.value === formData.notifications_settings.form_recipients_notification_type,
          );
        }

        if (formData.notifications_settings.form_initiator_notification_type) {
          newState.form_initiator_notification_type = notificationOptions.find(
            (item) => item.value === formData.notifications_settings.form_initiator_notification_type,
          );
        }

        if (formData.notifications_settings[SET_FORM_SUBMITTER_NOTIFICATION_KEY]) {
          newState[SET_FORM_SUBMITTER_NOTIFICATION_KEY] = formData.notifications_settings[SET_FORM_SUBMITTER_NOTIFICATION_KEY] ?? false;
        }

        if (formData.notifications_settings.should_notify_about_form_summary) {
          newState.form_summary_recipient_type = formSummaryRecipientOptions.find(
            (item) => item.value === formData.notifications_settings.form_summary_recipient_type,
          );
          newState.form_summary_notification_type = notificationOptions.find(
            (item) => item.value === formData.notifications_settings.form_summary_notification_type,
          );

          // if (formData.notifications_settings.form_summary_notification_sends_amount === 'once') {
          //   newState.form_summary_notification_should_be_sent_after_days_amount = formSummaryShouldBeSentAfterDaysOptions.find(
          //     (item) => item.value === formData.notifications_settings.form_summary_notification_should_be_sent_after_days_amount,
          //   );
          // }

          // if (formData.notifications_settings.form_summary_notification_sends_amount === 'many_times') {
          newState.form_summary_notification_sending_times = formSummarySendingTimesOptions.find(
            (item) => item.value === formData.notifications_settings.form_summary_notification_sending_times,
          );
          newState.form_summary_notification_sending_value = formSummarySendingValueOptions.find(
            (item) => item.value === formData.notifications_settings.form_summary_notification_sending_value,
          );
          newState.form_summary_notification_stop_type = formSummaryStopType.find(
            (item) => item.value === formData.notifications_settings.form_summary_notification_stop_type,
          );
          newState.form_summary_notification_sending_week_days =
            formData.notifications_settings.form_summary_notification_sending_week_days || [];
          newState.form_summary_notification_sending_month_days = formData.notifications_settings
            .form_summary_notification_sending_month_days
            ? formData.notifications_settings.form_summary_notification_sending_month_days.map(
                (item) =>
                  new DateObject({
                    year: 2024,
                    month: 12,
                    day: item,
                  }),
              )
            : [];

          newState.form_summary_notification_send_at_time = formData.notifications_settings.form_summary_notification_send_at_time
            ? timeOptions.find(
                (item) =>
                  item.value ==
                  dayjs(`1970-01-01 ${formData.notifications_settings.form_summary_notification_send_at_time}`, 'YYYY-MM-DD H:mm').format(
                    'h:mm A',
                  ),
              )
            : null;

          if (formData.notifications_settings.form_summary_notification_stop_type == 'interval') {
            newState.form_summary_notification_stop_period_times = formSummaryStopPeriodTimesOptions.find(
              (item) => item.value === formData.notifications_settings.form_summary_notification_stop_period_times,
            );
            newState.form_summary_notification_stop_period_value = formSummarySendingValueOptions.find(
              (item) => item.value === formData.notifications_settings.form_summary_notification_stop_period_value,
            );
          }
        }
        // }

        return newState;
      });
    }
    // eslint-disable-next-line
  }, [formData]);

  const handelSettings = (value, key) => {
    setNotificationsSettings((prevState) => {
      let newState;
      if (key === SET_FORM_SUBMITTER_NOTIFICATION_KEY && value === false) {
        newState = {
          ...prevState,
          [key]: value,
          submitters_notification_type: '',
          submitters_notification_text: '',
        };
      } else {
        newState = {
          ...prevState,
          [key]: value,
        };
      }

      return newState;
    });
  };

  const onUpdate = () => {
    const formData = {
      notifications_settings: JSON.parse(JSON.stringify(notifications_settings)),
    };

    const fieldsToExclude = [
      'form_summary_recipient_type',
      'form_summary_notification_type',
      'form_summary_send_form_completion',
      'form_summary_send_amount_of_people_who_submitted_form',
      'form_summary_send_amount_of_people_who_did_not_submit_form',
      'form_summary_send_list_of_people_who_submitted_form',
      'form_summary_send_list_of_people_who_did_not_submit_form',
      'form_summary_notification_sends_amount',
      'form_summary_notification_should_be_sent_after_days_amount',
      'form_summary_notification_sending_times',
      'form_summary_notification_sending_value',
      'form_summary_notification_send_at_time',
      'form_summary_notification_stop_type',
      'form_summary_notification_stop_on_date',
      'form_summary_notification_stop_period_times',
      'form_summary_notification_stop_period_value',
    ];

    fieldsToExclude.forEach((field) => {
      delete formData.notifications_settings[field];
    });

    if (notifications_settings.submitters_notification_type?.value) {
      formData.notifications_settings.submitters_notification_type = notifications_settings.submitters_notification_type.value;
    }
    if (notifications_settings.form_initiator_notification_type?.value) {
      formData.notifications_settings.form_initiator_notification_type = notifications_settings.form_initiator_notification_type.value;
    }

    if (notifications_settings.form_recipients_notification_type?.value) {
      formData.notifications_settings.form_recipients_notification_type = notifications_settings.form_recipients_notification_type.value;
    }

    if (!notifications_settings.should_form_initiator_receive_notifications) {
      delete formData.notifications_settings.form_initiator_notification_text;
      delete formData.notifications_settings.form_initiator_notification_type;
    }

    if (!notifications_settings.should_form_recipients_receive_notifications) {
      delete formData.notifications_settings.form_recipients_notification_text;
      delete formData.notifications_settings.form_recipients_notification_type;
    }

    if (notifications_settings.should_notify_about_form_summary) {
      formData.notifications_settings.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      formData.notifications_settings.form_summary_recipient_type = notifications_settings.form_summary_recipient_type?.value || null;
      formData.notifications_settings.form_summary_notification_type = notifications_settings.form_summary_notification_type?.value || null;
      formData.notifications_settings.form_summary_send_form_completion = notifications_settings.form_summary_send_form_completion;
      formData.notifications_settings.form_summary_send_amount_of_people_who_submitted_form =
        notifications_settings.form_summary_send_amount_of_people_who_submitted_form;
      formData.notifications_settings.form_summary_send_amount_of_people_who_did_not_submit_form =
        notifications_settings.form_summary_send_amount_of_people_who_did_not_submit_form;
      formData.notifications_settings.form_summary_send_list_of_people_who_submitted_form =
        notifications_settings.form_summary_send_list_of_people_who_submitted_form;
      formData.notifications_settings.form_summary_send_list_of_people_who_did_not_submit_form =
        notifications_settings.form_summary_send_list_of_people_who_did_not_submit_form;
      formData.notifications_settings.form_summary_notification_sends_amount =
        notifications_settings.form_summary_notification_sends_amount;

      // if (notifications_settings.form_summary_notification_sends_amount === 'once') {
      //   formData.notifications_settings.form_summary_notification_should_be_sent_after_days_amount =
      //     notifications_settings.form_summary_notification_should_be_sent_after_days_amount?.value || null;
      // } else if (notifications_settings.form_summary_notification_sends_amount === 'many_times') {
      formData.notifications_settings.form_summary_notification_sending_times =
        notifications_settings.form_summary_notification_sending_times?.value || null;
      formData.notifications_settings.form_summary_notification_sending_value =
        notifications_settings.form_summary_notification_sending_value?.value || null;

      if (formData.notifications_settings.form_summary_notification_sending_value == 'weekly') {
        formData.notifications_settings.form_summary_notification_sending_week_days =
          notifications_settings.form_summary_notification_sending_week_days;
      } else if (formData.notifications_settings.form_summary_notification_sending_value == 'monthly') {
        formData.notifications_settings.form_summary_notification_sending_month_days =
          notifications_settings.form_summary_notification_sending_month_days.map((item) => item.day);
      }

      formData.notifications_settings.form_summary_notification_send_at_time = notifications_settings.form_summary_notification_send_at_time
        ? notifications_settings.form_summary_notification_send_at_time.value
        : null;

      formData.notifications_settings.form_summary_notification_stop_type =
        notifications_settings.form_summary_notification_stop_type?.value || null;

      if (formData.notifications_settings.form_summary_notification_stop_type === 'specific_date') {
        formData.notifications_settings.form_summary_notification_stop_on_date =
          notifications_settings.form_summary_notification_stop_on_date
            ? dayjs(new Date(notifications_settings.form_summary_notification_stop_on_date.toString())).format(DATE_FORMAT)
            : null;
      } else if (formData.notifications_settings.form_summary_notification_stop_type === 'interval') {
        formData.notifications_settings.form_summary_notification_stop_period_times =
          notifications_settings.form_summary_notification_stop_period_times?.value || null;
        formData.notifications_settings.form_summary_notification_stop_period_value =
          notifications_settings.form_summary_notification_stop_period_value?.value || null;
      }
      // }
    }

    updateForm(id, formData)
      .then(() => {
        navigation(`/form-builder/${id}/place-in-form`);
      })
      .catch((e) => {
        console.log(e);
        if (e?.response?.data?.notifications_settings) {
          setErrors(e.response.data.notifications_settings);
        }
      });
  };

  return (
    <div className="form-builder-setting-tab-content">
      <div className="form-builder-recipient-settings">
        {formData?.name && (
          <div className="from-builder-title from-builder-title-setting">
            <h1>
              <img src="/images/file-big-icon.png" className="mr-2" alt="" />
              {formData.name}
            </h1>
          </div>
        )}
        <p className="info-text">
          <i className="icon-icon-info"></i> Set rules for notifications regarding Form submissions.
        </p>
        <span className="form-error mb-2 d-flex">{errors?.non_field_errors && errors.non_field_errors[0]}</span>

        {!formData?.submission_settings?.is_one_submitter && (
          <>
            {(formType === 'SPECIAL' || formType === 'MIXED') && (
              <div className="form-control-item-settings">
                {!formData?.submission_settings?.has_strict_order_of_submissions && (
                  <>
                    <div className="form-settings-label">
                      <label className="form-label form-label-big">Set up the notification to form submitters</label>
                      <span>Set up the notification to users, who were assigned as form submitters </span>
                    </div>

                    <div className="form-settings-inputs">
                      <div className="d-flex">
                        <div className={`form-control-radio`}>
                          <input
                            type="radio"
                            value="true"
                            name={SET_FORM_SUBMITTER_NOTIFICATION_KEY}
                            onChange={() => handelSettings(true, SET_FORM_SUBMITTER_NOTIFICATION_KEY)}
                            checked={notifications_settings[SET_FORM_SUBMITTER_NOTIFICATION_KEY]}
                          />
                          <span>Yes</span>
                        </div>
                        <div className={`form-control-radio`}>
                          <input
                            type="radio"
                            value="true"
                            name={SET_FORM_SUBMITTER_NOTIFICATION_KEY}
                            onChange={() => handelSettings(false, SET_FORM_SUBMITTER_NOTIFICATION_KEY)}
                            checked={!notifications_settings[SET_FORM_SUBMITTER_NOTIFICATION_KEY]}
                          />
                          <span>No</span>
                        </div>
                      </div>

                      {notifications_settings[SET_FORM_SUBMITTER_NOTIFICATION_KEY] && (
                        <>
                          <div
                            className={`form-control-item-group form-item form-item-select ${errors?.submitters_notification_type ? 'form-item-error' : ''}`}
                          >
                            <label className="form-label">Notification type</label>
                            <div className="select-multy-wrapper">
                              <Select
                                hideSelectedOptions={false}
                                isSearchable={false}
                                options={notificationOptions}
                                onChange={(e) => handelSettings(e, 'submitters_notification_type')}
                                value={notifications_settings.submitters_notification_type}
                                className="form-control-select"
                                placeholder="Sms / Email"
                                classNamePrefix="react-select"
                              />
                              <span className="form-error">
                                {errors?.submitters_notification_type && errors.submitters_notification_type[0]}
                              </span>
                            </div>
                          </div>
                          <div className="form-control-item-group">
                            <label className="form-label">Notification text</label>
                            <textarea
                              onChange={(e) => handelSettings(e.target.value, 'submitters_notification_text')}
                              value={notifications_settings.submitters_notification_text}
                              placeholder={
                                'Enter notification or message text that will be sent to users  who were assigned as form submitters'
                              }
                              className="form-control"
                            />
                            <span className="form-error">
                              {errors?.submitters_notification_text && errors.submitters_notification_text[0]}
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                )}
              </div>
            )}
          </>
        )}

        {formData?.submission_settings?.filling_type !== 'MIXED' && (
          <>
            <div className="form-control-item-settings">
              <div className="form-settings-label">
                <label className="form-label form-label-big">Notify recipients about filled form</label>
                <span>Notification sent to recipients when the form has been completely filled out by all submitters</span>
              </div>
              <div className="form-settings-inputs">
                <div className="d-flex">
                  <div className={`form-control-radio`}>
                    <input
                      name="should_form_recipients_receive_notifications"
                      type="radio"
                      value="true"
                      onChange={() => handelSettings(true, 'should_form_recipients_receive_notifications')}
                      checked={notifications_settings.should_form_recipients_receive_notifications}
                    />
                    <span>Yes</span>
                  </div>
                  <div className={`form-control-radio`}>
                    <input
                      name="should_form_recipients_receive_notifications"
                      type="radio"
                      value="true"
                      onChange={() => handelSettings(false, 'should_form_recipients_receive_notifications')}
                      checked={!notifications_settings.should_form_recipients_receive_notifications}
                    />
                    <span>No</span>
                  </div>
                </div>

                {notifications_settings.should_form_recipients_receive_notifications && (
                  <>
                    <div className="form-control-item-group">
                      <label className="form-label">Notification type</label>
                      <div className="select-multy-wrapper">
                        <Select
                          hideSelectedOptions={false}
                          isSearchable={false}
                          options={notificationOptions}
                          value={notifications_settings.form_recipients_notification_type}
                          onChange={(e) => handelSettings(e, 'form_recipients_notification_type')}
                          className="form-control-select"
                          placeholder="Sms / Email"
                          classNamePrefix="react-select"
                        ></Select>
                      </div>
                      <span className="form-error">
                        {errors?.form_recipients_notification_type && errors.form_recipients_notification_type[0]}
                      </span>
                    </div>
                    <div className="form-control-item-group">
                      <label className="form-label">Notification text</label>
                      <textarea
                        onChange={(e) => handelSettings(e.target.value, 'form_recipients_notification_text')}
                        value={notifications_settings.form_recipients_notification_text}
                        placeholder={'Enter notification or message text that will be sent to users  who were assigned as form submitters'}
                        className="form-control"
                      ></textarea>
                      <span className="form-error">
                        {errors?.form_recipients_notification_text && errors.form_recipients_notification_text[0]}
                      </span>
                    </div>

                    {notifications_settings.form_recipients_notification_type?.value === 'EMAIL' && (
                      <AttachPdfToEmailSetting
                        id={'should_form_recipients_receive_pdf_with_submissions'}
                        value={notifications_settings.should_form_recipients_receive_pdf_with_submissions}
                        onChange={handelSettings}
                      />
                    )}
                  </>
                )}
              </div>
            </div>
            {!formData?.submission_settings?.is_one_submitter && (
              <div className="form-control-item-settings">
                <div className="form-settings-label">
                  <label className="form-label form-label-big">Notify initiator about filled form</label>
                  <span>Notification to the form initiator when the form has been completely filled out by all submitters</span>
                </div>
                <div className="form-settings-inputs">
                  <div className="d-flex">
                    <div className={`form-control-radio`}>
                      <input
                        name="should_form_initiator_receive_notifications"
                        type="radio"
                        value="true"
                        onChange={() => handelSettings(true, 'should_form_initiator_receive_notifications')}
                        checked={notifications_settings.should_form_initiator_receive_notifications}
                      />
                      <span>Yes</span>
                    </div>
                    <div className={`form-control-radio`}>
                      <input
                        name="should_form_initiator_receive_notifications"
                        type="radio"
                        value="true"
                        onChange={() => handelSettings(false, 'should_form_initiator_receive_notifications')}
                        checked={notifications_settings.should_form_initiator_receive_notifications === false}
                      />
                      <span>No</span>
                    </div>
                  </div>

                  {notifications_settings.should_form_initiator_receive_notifications && (
                    <>
                      <div className="form-control-item-group">
                        <label className="form-label">Notification type</label>
                        <div className="select-multy-wrapper">
                          <Select
                            hideSelectedOptions={false}
                            isSearchable={false}
                            options={notificationOptions}
                            value={notifications_settings.form_initiator_notification_type}
                            onChange={(e) => handelSettings(e, 'form_initiator_notification_type')}
                            className="form-control-select"
                            placeholder="Sms / Email"
                            classNamePrefix="react-select"
                          ></Select>
                        </div>
                        <span className="form-error">
                          {errors?.form_initiator_notification_type && errors.form_initiator_notification_type[0]}
                        </span>
                      </div>
                      <div className="form-control-item-group">
                        <label className="form-label">Notification text</label>
                        <textarea
                          onChange={(e) => handelSettings(e.target.value, 'form_initiator_notification_text')}
                          value={notifications_settings.form_initiator_notification_text}
                          placeholder={
                            'Enter notification or message text that will be sent to users  who were assigned as form submitters'
                          }
                          className="form-control"
                        ></textarea>
                        <span className="form-error">
                          {errors?.form_initiator_notification_text && errors.form_initiator_notification_text[0]}
                        </span>
                      </div>

                      {notifications_settings.form_initiator_notification_type?.value === 'EMAIL' && (
                        <AttachPdfToEmailSetting
                          id={'should_form_initiator_receive_pdf_with_submissions'}
                          value={notifications_settings.should_form_initiator_receive_pdf_with_submissions}
                          onChange={handelSettings}
                        />
                      )}
                    </>
                  )}
                </div>
              </div>
            )}
            {formType == 'SPECIAL' &&
              formData?.submission_settings?.is_one_submitter === false &&
              !formData?.submission_settings?.can_initiator_specify_form_summary_settings && (
                <div className="form-control-item-settings">
                  <div className="form-settings-label">
                    <label className="form-label form-label-big">
                      Notify the form initiator or recipient of the form activity after initiation
                    </label>
                  </div>
                  <div className="form-settings-inputs">
                    <div className="d-flex">
                      <div className={`form-control-radio`}>
                        <input
                          name="should_notify_about_form_summary"
                          type="radio"
                          value="true"
                          onChange={() => handelSettings(true, 'should_notify_about_form_summary')}
                          checked={notifications_settings.should_notify_about_form_summary}
                        />
                        <span>Yes</span>
                      </div>
                      <div className={`form-control-radio`}>
                        <input
                          name="should_notify_about_form_summary"
                          type="radio"
                          value="false"
                          onChange={() => handelSettings(false, 'should_notify_about_form_summary')}
                          checked={notifications_settings.should_notify_about_form_summary === false}
                        />
                        <span>No</span>
                      </div>
                    </div>
                    {notifications_settings.should_notify_about_form_summary && (
                      <FormSummarySettings
                        handelSettings={handelSettings}
                        notifications_settings={notifications_settings}
                        errors={errors}
                      />
                    )}
                  </div>
                </div>
              )}
          </>
        )}
      </div>

      <div className="form-control-actions">
        <button
          className="btn btn-outline"
          onClick={() => {
            if (formData.submission_settings?.filling_type === 'SPECIAL') {
              navigation(`/form-builder/${id}/settings/recipient`);
            } else if (formData.submission_settings?.filling_type === 'MIXED') {
              navigation(`/form-builder/${id}/settings/submission`);
            }
          }}
        >
          Back to {formData.submission_settings?.filling_type === 'SPECIAL' ? 'Recipient' : 'Submission'} Settings
        </button>
        <button className="btn" onClick={onUpdate}>
          Save Changes
        </button>
      </div>
    </div>
  );
};
